import { IColor4, IVector3 } from '../../../api.js';
export const GIZMO_AXIS_COLOR = {
    x: new IColor4(1.0, 0.2, 0.0, 1.0), // RED
    y: new IColor4(0.8, 1.0, 0.0, 1.0), // GREEN
    z: new IColor4(0.2, 0.2, 1.0, 1.0), // BLUE
    center: new IColor4(1, 1, 1, 1) // WHITE
};
export const GIZMO_COLOR_FACTOR = {
    active: new IVector3(1.6),
    not_active: new IVector3(0.85)
};
//# sourceMappingURL=GizmoColors.js.map